module.exports = __webpack_public_path__ + "static/media/semuClientSample.169ef71f.xlsx";